import { useReducer } from 'react';
import { FormField, TextInput, Anchor } from 'grommet';
import { HelpWith } from '@components/basicComponents';
import { HelpWithType } from '@customTypes/enums';
import type { FormFieldsProps } from '@customTypes/types';
import type { OpsRampFormFieldsState } from '@customTypes/stateTypes';
import { helpWithOptions } from './OpsRampFormOptions';

export const OpsRampFormFields = (props: FormFieldsProps): JSX.Element => {
  const [state, updateState] = useReducer(
    (prev: OpsRampFormFieldsState, newState: Partial<OpsRampFormFieldsState>) => ({
      ...prev,
      ...newState,
    }),
    {
      helpWith: '',
      showContractIdentifier: false,
      showLicenseKey: false
    }
  );

  const helpWithChange = (option: string): void => {
    if (option === state.helpWith) {
      return;
    }

    clearFirstSelectState();
    updateState({
      helpWith: option,
      showContractIdentifier: true,
      showLicenseKey: true
    });
    props.onDetailsChange({ showDetails: true });
  };

  const clearState = (): void => {
    clearFirstSelectState();
    updateState({ helpWith: '' });
  };

  props.onReset && props.onReset(clearState);

  const clearFirstSelectState = (): void => {
    updateState({ showContractIdentifier: false, showLicenseKey: false });
    props.onDetailsChange({ showDetails: false });
  };

  return (
    <>
      <Anchor href="https://www.opsramp.com/about-opsramp/contact-us/"
        target="_blank"
        label="Sales and Pricing"></Anchor>

      <HelpWith
        selectType={!props.isConsolidated ? HelpWithType.First : HelpWithType.Second}
        options={Object.values(helpWithOptions)}
        onChange={helpWithChange}
      />

      {state.showContractIdentifier &&
        <FormField name="contractIdentifier" htmlFor="contract-identifier" label="Contract Identifier">
          <TextInput id="contract-identifier" name="contractIdentifier" placeholder="Contract Identifier" />
        </FormField>
      }

      {state.showLicenseKey &&
        <FormField name="licenseKey" htmlFor="license-key" label="License Key">
          <TextInput id="license-key" name="licenseKey" placeholder="License Key" />
        </FormField>
      }
    </>
  );
};
